module.exports = __webpack_public_path__ + "static/media/sdmt3.5b3dcd55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt3.svg
// module id = 343
// module chunks = 0